/*
 * Copyright (c) Nexign, JSC, 2019.
 */
/**
 *
 *
 * @author Aleksandr Perkhunov
 * @version 1.0.0
 * @since 1.0.0
 */

import styled from 'styled-components';

import { fonts } from '../../../../../theme';
import { FormWrapperStyled } from '../../../styled/PageAuthStyled';

const Column = styled.div`
    display: block;
    width: 100%;
    & .recovery-form__ussd-message {
        margin-bottom: 40px;
    }
`;
const Question = styled.p.attrs({
    className: 'recovery-form__question',
})`
    ${fonts.textMainBold};
    ${FormWrapperStyled} & {
        margin-bottom: 1rem;
        margin-top: -1rem;
    }
`;
export {
    Column,
    Question,
};
